import reducer from './reducers';
import * as authActions from './actions';

export { authActions };
export default reducer;
